import React from "react";
import {  Query, Loading} from "../../components";
// import TestDescription from "../../components/TestDescription";
import Questions from "./questions";
import { getBookmarkedQuestions } from "../../lib/api";

const BookmarkedQuestions = ({
  match: {
    params: { subjectId }
  }
}) => {
  return (
    <>
      <Query query={() => getBookmarkedQuestions(subjectId)}>
        {({ loading, data }) => {
          if (loading) {
            return <Loading />;
          }
          return <Questions {...data} />
          
        }}
      </Query>
    </>
  );
};

export default BookmarkedQuestions;
